import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {Injectable} from '@angular/core';
import {environment} from '@environments/environment';
import {STARTUP_HELGA} from '@global/mock-data/startuphelga';
import {STARTUP_SPARK} from '@global/mock-data/startupspark';

const urls = [
  {
    url: 'v1/startup/5a73243e-7bc8-11e9-8f9e-2a86e4085a59',
    method: 'GET',
    json: STARTUP_SPARK,
  },
  {
    url: 'v1/startup/2',
    method: 'GET',
    json: STARTUP_HELGA,
  },
];

@Injectable()
export class HttpMockRequestInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (environment.enableMockData) {
      for (const element of urls) {
        if (request.url.endsWith(element.url) && request.method === element.method) {
          console.log('Mocked: ' + request.method + ' ' + request.url);
          return of(new HttpResponse({status: 200, body: (element.json as any).default}));
        }
      }
    }
    return next.handle(request);
  }
}
